import React from "react";
import { Dialog } from "@mui/material";

const ModalNewProductionDeprecated = ({ open, setOpen }) => {
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <div className="w-[360px] p-6 text-center flex flex-col items-center justify-center gap-4">
        <h2 className="text-xl font-bold text-gray-800">Secoset déménage !</h2>
        <p className="text-gray-600">
          Merci pour votre intérêt pour le Secoset.
          <br />
          Nous avons le plaisir de vous annoncer que le Secoset évolue et s&apos;intègre désormais pleinement à notre nouvelle plateforme <strong>Flying Secoya</strong>.
          <br /><br />
          Pour vous inscrire et découvrir cette nouvelle expérience :
        </p>
        <a
          href="https://app.flyingsecoya.io/register?view=login"
          target="_blank"
          rel="noopener noreferrer"
          className="blue-button w-full text-center"
        >
          Aller sur Flying Secoya
        </a>
        <p className="text-gray-600">À très bientôt sur Flying Secoya !</p>
      </div>
    </Dialog>
  );
};

export default ModalNewProductionDeprecated;
